import { GetCurrentDocument, GetCurrentQuery } from 'generated/resources/graphql'
import moment from 'moment'

import { useQuery } from 'modules/core/hooks/useQuery'

import { dateToString } from '../lib/dates'

type Current = GetCurrentQuery['apiCore']['currentsConnection']['edges'][number]['node']

export interface Session
  extends Pick<
    Current,
    'company' | 'access' | 'employee' | 'email' | 'isAdminBecome' | 'isStaffBecome'
  > {
  isIntercomAllowed: boolean

  // FIXME: Stop adding new policies to this hook!!!!!!
  canManageTimeoff: boolean
  canManageSubscription: boolean
  canSeeEmployeeProfile: boolean
  canCreateEmployees: boolean
  canCreateTeams: boolean
  canRequestUpsell: boolean
  canSeeProductUpdates: boolean
  canSelfUpsell: boolean

  allMyDescendants: number[]
}

export const useGetCurrentSession = () => {
  const { loading, data } = useQuery(GetCurrentDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      contractVersionsActiveOn: dateToString(moment(), 'backend'),
    },
  })

  const current = data && data.apiCore.currentsConnection.edges.at(0)?.node

  return {
    loading,
    company: current?.company,
    access: current?.access,
    employee: current?.employee,
    email: current?.email,
    isAdminBecome: current?.isAdminBecome ?? false,
    isStaffBecome: current?.isStaffBecome ?? false,
    allMyDescendants: data?.employees.allMyDescendants.map((descendant) => descendant.id) ?? [],
    isIntercomAllowed: data?.intercom._policies.allowIntercom.can ?? false,

    // FIXME: Stop adding new policies to this hook!!!!!!
    canManageTimeoff: data?.timeoff._policies.companyManageTimeoff.can ?? false,
    canManageSubscription: data?.billing._policies.subscriptionManageSubscription.can ?? false,
    canSeeEmployeeProfile: data?.apiCore._policies.companySeeEmployeeProfile.can ?? false,
    canCreateTeams: data?.teams._policies.teamCreate.can ?? false,
    canCreateEmployees: data?.apiCore._policies.employeeCreate.can ?? false,
    canRequestUpsell: data?.upsell._policies.canRequestUpsell.can ?? false,
    canSeeProductUpdates:
      data?.productUpdates._policies.sidebarSeeProductUpdatesSubLevelItem.can ?? false,
    canSelfUpsell: data?.billing._policies.subscriptionUpgradeSubscription.can ?? false,
  }
}
